import React from 'react';
import { useNavigate } from 'react-router-dom';
import cookie from "universal-cookie";

const ParticipantFooter = ({ activeTab, onTabChange }) => {
    const navigate = useNavigate();
    const cookies = new cookie();

    const handleLogout = () => {
        const cookieNames = ['auto_login_code', 'auth_key', 'surname', 'name', 'email', 'authenticated', 'user_type'];
        cookieNames.forEach(cookieName => cookies.remove(cookieName));
        navigate('/login');
    };

    const handleProfile = () => {
        // const cookieNames = ['auto_login_code', 'auth_key', 'surname', 'name', 'email', 'authenticated', 'user_type'];
        // cookieNames.forEach(cookieName => cookies.remove(cookieName));
        navigate('/cbt_creator/profile');
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white shadow-2xl border-t border-gray-200 z-40">
            <div className="max-w-md mx-auto">
                <div className="flex justify-around items-center py-3">
                    <button
                        onClick={() => onTabChange('dashboard')}
                        className={`flex flex-col items-center px-4 py-2 rounded-2xl transition-all duration-200 ${
                            activeTab === 'dashboard' 
                                ? 'text-blue-600 bg-blue-50 transform -translate-y-1 shadow-sm' 
                                : 'text-gray-500 hover:text-blue-600'
                        }`}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 mb-1 ${activeTab === 'dashboard' ? 'text-blue-600' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        <span className="text-xs font-medium">Dashboard</span>
                    </button>


                    
                    <button
                        onClick={handleProfile}
                        className="flex flex-col items-center px-4 py-2 rounded-2xl text-gray-500 hover:text-red-600 transition-all duration-200"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mb-1 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        <span className="text-xs font-medium">Profile</span>
                    </button>


                    <button
                        onClick={handleLogout}
                        className="flex flex-col items-center px-4 py-2 rounded-2xl text-gray-500 hover:text-red-600 transition-all duration-200"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mb-1 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        <span className="text-xs font-medium">Logout</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ParticipantFooter;